import { Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";

interface PMLoadingStateProps {
  /** Optional short label shown under the spinner. Defaults to no label. */
  label?: string;
  className?: string;
}

/**
 * Centered spinner used as the initial-fetch placeholder for every PM page.
 *
 * Why its own component: the previous render logic (`items.length === 0 &&
 * !isLoading`) flashed the "has data" list layout briefly on first render
 * because `isLoading=true` fell through to the list branch. Having an explicit
 * loading branch that renders this component prevents that flash entirely.
 */
export function PMLoadingState({ label, className }: PMLoadingStateProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "flex flex-col items-center justify-center gap-3 px-8 py-16 text-center",
        className
      )}
    >
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground/60" />
      {label && <p className="text-xs text-muted-foreground">{label}</p>}
    </div>
  );
}
